import { AdditionalDocument } from '../models/additional-document';

/**
 * Map to additional document.
 * @param {object} dto Dto.
 * @returns {AdditionalDocument}
 */
function fromDto(dto) {
  return new AdditionalDocument({
    name: dto.name,
    code: dto.code,
  });
}

export const additionalDocumentMapper = {
  fromDto,
};
